import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { InclusionSection } from '../components/InclusionSection';
import { PromiseSection } from '../components/PromiseSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { OfferSection } from '../components/OfferSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTA } from '../components/FinalCTA';
export function SalesPage() {
  return <div className="w-full min-h-screen bg-cream font-body" data-id="element-130">
      <Hero data-id="element-131" />
      <ProblemSection data-id="element-132" />
      <SolutionSection data-id="element-133" />
      <InclusionSection data-id="element-134" />
      <PromiseSection data-id="element-135" />
      <TestimonialsSection data-id="element-136" />
      <OfferSection data-id="element-137" />
      <FAQSection data-id="element-138" />
      <FinalCTA data-id="element-139" />
    </div>;
}